module.exports = __webpack_public_path__ + "static/media/backWave5.bb152b26.svg";